<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px"/>
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Terméksorrend</span>
          <el-button
            :loading="loading"
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            v-can="'data.productorder.update'"
            @click="save"
          >
            Mentés
          </el-button>
        </div>
        <list ref="productList"/>
      </el-card>
    </div>
  </div>
</template>
<script>
import Sidebar from '../../../components/data/products/Sidebar';
import List from '../../../components/data/products/productsOrder/List';

export default {
  components: {
    Sidebar,
    List,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async save() {
      this.loading = true;
      try {
        await axios.post('api/products/order', {
          products: this.$refs['productList'].products,
        });
        this.$refs['productList'].fetchProducts();
      } catch (e) {
      }
      this.loading = false;
    },
  },
};
</script>
